import { Api } from "./Api";

export default {
    getSchedules(domainId, limit, page, pageLength)
    {
        return Api.get(`/v1/schedules/get?where[is_active]=1&with[drips]=id,domain_id,title,body,customization,icon,url,type,group_id&with[audiences]=id,name&where[type]=spam-recurring&where[domain_id]=${domainId}&page=${page}&order_by=id:desc&limit=${limit}&paginate=true&pageLength=${pageLength}`);

    },
    createOrUpdate(schedule)
    {
        return Api.post('/v1/schedules/createOrUpdateSpam', schedule);
    },
    delete(id)
    {
        return Api.delete(`/v1/schedules/${id}`);
    },
    // getDripsByScheduleId(domainId, limit, page, pageLength)
    // {
    //     return Api.get(`/v1/schedules/get?where[is_active]=1&with[drips]=id&with[audiences]=id&where[type]=spam-recurring&where[domain_id]=${domainId}&page=${page}&order_by=id:desc&limit=${limit}&paginate=true&pageLength=${pageLength}`);
    // }
};
